import React, { useMemo} from "react";
import {Formik, Form, Field} from "formik";
import * as Yup from "yup";
import { AEInput } from "../../../../../_metronic/_partials/controls";
import { languages } from "../../../../../_emywork/helpers/UIHelper";

export function EditForm({ entity, btnRef, saveEntity, validationErrors = []}) {

  const EditSchema = useMemo(()=>{
    return Yup.object().shape({
      name_ar: Yup.string().required() ,
      name_en: Yup.string().required() ,
      name_fr: Yup.string().required() ,
      name_es: Yup.string().required() ,
    })
  }
  ,[])



  return (
    <>
      <Formik
        enableReinitialize
        initialValues={entity}
        initialErrors={validationErrors}
        validationSchema={EditSchema}
        onSubmit={(values) => {
          saveEntity(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (

          <Form className="form form-label-right">
              {
                languages.map(l=>(
                  <div key={l.lang} className="form-group row">
                    <div className={"col-lg-12"}>
                      <Field
                        name={`name_${l.lang}`}
                        component={AEInput}
                        label={`LANG.${l.lang.toUpperCase()}`}
                        // customFeedbackLabel={formatMessage({id:'FORM.MULTI_LANG.NAME'},{lang:formatMessage({id:`LANG.${l.lang.toUpperCase()}`})})}
                        dir={l.rtl?'rtl':'ltr'}
                      />
                    </div>
                  </div>
                ))
              }

            <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={handleSubmit}
            />
        </Form>
        )}
      </Formik>
    </>
  );
}
